// <s-whatsapp-float> lets shoppers collapse the floating WhatsApp button to a small tab and bring it back.
// The collapsed choice is remembered for 30 days.
const KEY = 'eluna:whatsapp-hidden-until';
const DAYS = 30;

class WhatsappFloat extends HTMLElement {
  connectedCallback() {
    this.full = this.querySelector('[data-whatsapp-full]');
    this.tabWrap = this.querySelector('[data-whatsapp-tab]');
    this.tab = this.querySelector('[data-whatsapp-show]');
    this.#render(this.#isHidden());

    this.querySelector('[data-whatsapp-hide]')?.addEventListener('click', () => {
      this.#store(Date.now() + DAYS * 864e5);
      this.#render(true);
      this.tab?.focus();
    });
    this.tab?.addEventListener('click', () => {
      this.#store(0);
      this.#render(false);
      this.full?.querySelector('a')?.focus();
    });
  }

  #render(collapsed) {
    if (this.full) this.full.hidden = collapsed;
    if (this.tabWrap) this.tabWrap.hidden = !collapsed;
  }

  #store(value) {
    try {
      if (value) localStorage.setItem(KEY, String(value));
      else localStorage.removeItem(KEY);
    } catch {
      // Storage can be blocked; the state still applies for this page view.
    }
  }

  #isHidden() {
    try {
      return Number(localStorage.getItem(KEY) || 0) > Date.now();
    } catch {
      return false;
    }
  }
}

if (!customElements.get('s-whatsapp-float')) customElements.define('s-whatsapp-float', WhatsappFloat);
